// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ResizablePanels/styles.scss
// module id = 1372
// module chunks = 0